import { OEText } from '@openeducation/oe-it-components';
import { styled } from '@openeducation/oe-it-themes';
import React from 'react';

export interface TimerItemProps {
  label?: string;
  value?: string;
}

export const TimerItem = ({ label, value }: TimerItemProps) => {
  return (
    <Container>
      <OEText fontSize={40} fontType="bold">
        {value}
      </OEText>
      <TimerLabel fontSize={10} fontType="medium">
        {label}
      </TimerLabel>
    </Container>
  );
};

const Container = styled.View`
  flex-direction: column;
  background-color: ${({ theme }) => theme.color.lightPrimary};
  border-radius: 8px;
  width: 72px;
  height: 86px;
  align-items: center;
  justify-content: center;
`;

const TimerLabel = styled(OEText)`
  text-transform: uppercase;
`;
